export const FOOD_CATEGORIES = new Set([
  "Bakery", "Cafes & Drinks", "Dessert & Ice Cream", "Fast Food",
  "Grocery", "Restaurant",
]);

export const isPercentDeal = (offer) => {
  const vr = (offer.value_range || '').toLowerCase();
  return vr.includes('%');
};

export const getValueDisplay = (offer) => {
  if (isPercentDeal(offer)) {
    const source = offer.value_range || '';
    const match = source.match(/(\d+)%/);
    if (match) return { label: 'discount', value: `${match[1]}% off`, isPercent: true };
  }
  if (!offer.offer_value_est || offer.offer_value_est <= 0) return null;
  return { label: 'worth', value: `~$${offer.offer_value_est}`, isPercent: false };
};
